import { getChargebeeProductId } from './get-chargebee-product-id'

export const isProductionBilling = (subscription?: any): boolean => {
  if (!subscription) {
    return false
  }
  const productionPlanIds = [getChargebeeProductId('sales-2026-monthly'), getChargebeeProductId('sales-2026-yearly')]
  return !!(
    productionPlanIds.includes(subscription.plan_id) ||
    subscription.subscription_items?.some((item: any) => productionPlanIds.includes(item.item_price_id))
  )
}
